import { SelectInput } from "@visiblethread/react-components";
import clsx from "clsx";
import { noop } from "lodash";
import { func, string } from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentStyleTemplates } from "slices/settings/actions/addInSettings";
import { selectDocumentStyleTemplates } from "slices/settings/selectors/addInSettingsSelectors";

import classes from "./DocStyleTemplatesDropdown.module.scss";

export const TEMPLATES_ERROR_MESSAGE =
  "Please select a Style Template to continue";

export const TEMPLATES_HINT_MESSAGE =
  "Your new document will acquire the styles in this template.";

export const NO_TEMPLATE_ID = false;

const DocStyleTemplatesDropdown = ({
  error,
  label = "Style Template",
  onSelect = noop,
  placeholder = "Select a Style Template",
}) => {
  const styleTemplates = useSelector(selectDocumentStyleTemplates);
  const [templateId, setTemplateId] = useState();
  const dispatch = useDispatch();
  const hasError = Boolean(error);

  const options = useMemo(
    () =>
      styleTemplates
        .map(({ id, name }) => ({
          label: name,
          value: id,
        }))
        .concat({
          label: "No Template",
          value: NO_TEMPLATE_ID,
        }),
    [styleTemplates]
  );

  useEffect(() => {
    dispatch(fetchDocumentStyleTemplates());
  }, []);

  const onChange = (id) => {
    setTemplateId(id);
    onSelect(id);
  };

  return (
    <>
      <SelectInput
        className={classes.select}
        error={error}
        id="doc-style-template-dropdown"
        label={label}
        onChange={onChange}
        optionListClassName={classes.options}
        options={options}
        placeholder={placeholder}
        value={templateId}
      />
      <span
        aria-live="polite"
        className={clsx(classes.suffix, hasError && classes.error)}
        data-testid="doc-style-template-dropdown-hint"
        role={hasError ? "alert" : undefined}
      >
        {hasError ? error : TEMPLATES_HINT_MESSAGE}
      </span>
    </>
  );
};

DocStyleTemplatesDropdown.propTypes = {
  error: string,
  label: string,
  onSelect: func,
  placeholder: string,
};

export default DocStyleTemplatesDropdown;
